import { render, staticRenderFns } from "./cart-header.vue?vue&type=template&id=6dc6a4fe&scoped=true&lang=pug&"
import script from "./cart-header.vue?vue&type=script&lang=coffee&"
export * from "./cart-header.vue?vue&type=script&lang=coffee&"
import style0 from "./cart-header.vue?vue&type=style&index=0&id=6dc6a4fe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc6a4fe",
  null
  
)

export default component.exports